import { useState } from "react";
import { Bell, Mail, Check } from "lucide-react";
import { api, errMsg } from "../../lib/api";

function EmailForm({ url, extra = {}, cta, Icon, testId, done }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ busy: false, ok: false, err: "" });
  const submit = async (e) => {
    e.preventDefault();
    setState({ busy: true, ok: false, err: "" });
    try { await api.post(url, { email, ...extra }); setState({ busy: false, ok: true, err: "" }); } catch (x) { setState({ busy: false, ok: false, err: x.response?.status === 422 ? "Please enter a valid email address." : errMsg(x) }); }
  };
  if (state.ok) return <p className="flex items-center gap-2 text-sm text-emerald-300" data-testid={`${testId}-success`}><Check size={16} />{done}</p>;
  return (
    <form onSubmit={submit} className="flex flex-wrap gap-2" data-testid={`${testId}-form`}>
      <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" aria-label="Email address"
        className="flex-1 min-w-[200px] h-11 rounded-lg bg-black/40 border border-amber-500/40 px-4 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-amber-300 transition-colors" data-testid={`${testId}-email`} />
      <button disabled={state.busy} className="glow-btn h-11 inline-flex items-center gap-2 bg-amber-600 hover:bg-amber-500 text-white px-5 rounded-lg font-medium border border-amber-300/40 disabled:opacity-60 transition-colors" data-testid={`${testId}-submit`}>
        <Icon size={15} />{state.busy ? "Sending…" : cta}</button>
      {state.err && <p className="w-full text-xs text-red-400" data-testid={`${testId}-error`}>{state.err}</p>}
    </form>
  );
}

export function RemindMe({ slug }) {
  return (
    <div className="panel p-4 mt-4" data-testid="remind-me">
      <p className="font-display text-sm mb-1">Tell me when it's out</p>
      <p className="text-[11px] text-slate-500 mb-3">One email on release day. Nothing else.</p>
      <EmailForm url={`/public/books/${slug}/remind`} cta="Remind me" Icon={Bell} testId="remind" done="You're on the list — we'll email you on release day." />
    </div>
  );
}

export function NewsletterSignup() {
  return (
    <section className="relative overflow-hidden border-t border-amber-500/15" data-testid="newsletter-section">
      <div className="smoke" />
      <div className="relative max-w-3xl mx-auto px-4 sm:px-8 py-16 text-center">
        <p className="eyebrow mb-3">The inner circle</p>
        <h2 className="font-display text-3xl sm:text-4xl">Join the newsletter</h2>
        <p className="text-slate-400 mt-3 mb-8 max-w-lg mx-auto text-sm sm:text-base">New releases, behind-the-scenes notes and first looks at covers. Unsubscribe any time.</p>
        <div className="max-w-md mx-auto text-left"><EmailForm url="/public/newsletter" cta="Join" Icon={Mail} testId="newsletter" done="Welcome aboard — you've joined the newsletter." /></div>
      </div>
    </section>
  );
}
